import { Divider } from '@mantine/core'

export const DividerThemeKobo = Divider.extend({
  defaultProps: {
    color: 'gray.7',
  },
})
